export default __webpack_public_path__ + "static/media/head02_en_pc.2e21fca7.png";